import { ProviderCaseStatusGetDTO } from "../../providers/provider.model";

export function isClosed(
  status: string,
  statusApi: ProviderCaseStatusGetDTO[]
): boolean {
  const statusFound = statusApi.find(
    (s) => s.value.toLowerCase() === status.toLowerCase()
  );
  return statusFound?.isStatusTypeClosed ?? false;
}
